/* eslint-disable react/prop-types */
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import Logo from '../../../assets/logos/xama-logo.png';
import { RocketIcon } from '../../../assets/svgs/icons';
import { MessagePopUp } from '../../../components/MessagePopUp';
import {
  ArtPendingCancelPopUp,
  PrimaryButton,
  SecondaryButton,
} from '../../../components';
import { useClient } from '../../../hooks/useClient';
import {
  ArtStatusService,
  BrandingArchetypeService,
  BrandingService,
  BusinessService,
  EditorialLineService,
  EventMapService,
  FreepikService,
  LogosService,
  OrchestratorImageGenerationService,
  OrchestratorTextGenerationService,
  PythonService,
  SubscriptionService,
  TargetAudienceService,
  UserPlanCount,
  VoiceToneService,
} from '../../../services';
import { postPromptGPT } from '../../../services/pythonService';
import {
  notifyErrorCustom,
  notifySuccessCustom,
  notifyWarningCustom,
  notifyWarningCustom2,
} from '../../../utils/notify';
import {
  consumeGeneratedArts,
  getArtGenerationAvailability,
  mergeConsumedArtStatusIds,
} from '../../../utils/artConsumption';
import { isEmpty } from '../../../utils/verifyObject';
import { EditArtField } from './components/EditArtField';
import { EditLegendField } from './components/EditLegendField';
import { ImageField, ImageFieldMemoized } from './components/ImageField';
import { LoadingLayoutMemoized } from './components/LoadingLayout';
import { ChatTimerContext } from '../../../contexts/ChatTimerContext/ChatTimerContext';
import { useGoogleAdsTracking } from '../../../utils/googleAdsTracking';
import { UseGenerateArt } from '../../../hooks/useGenerateArt';
import { ArtPedingContext } from '../../../contexts/ArtPendingContext/ArtPendingContext';
import { SideMenuContext } from '../../../contexts/SideMenuContext/CheckUserMissionContext';

const DEFAULT_BRAND_COLORS = ['#000000', '#FFFFFF', '#7A7E00'];

const getBusinessRecord = (businessData) =>
  businessData?.businessInfos?.data?.[0] ?? null;

const getBrandingRecord = (businessData) =>
  businessData?.brandingInfos?.data?.[0] ?? null;

const resolveNiche = (businessData, prompt) => {
  const business = getBusinessRecord(businessData);

  return (
    business?.otherNicheName ||
    business?.BusinessNiche?.name ||
    prompt?.trim() ||
    'Geral'
  );
};

const resolveBrandColors = (businessData) => {
  const branding = getBrandingRecord(businessData);

  return [
    branding?.primaryColor || DEFAULT_BRAND_COLORS[0],
    branding?.secondaryColor || DEFAULT_BRAND_COLORS[1],
    branding?.tertiaryColor || DEFAULT_BRAND_COLORS[2],
  ];
};

const EMPTY_BUSINESS_DATA = {
  brandingInfos: { data: [] },
  voiceToneInfos: { data: [] },
  businessInfos: { data: [] },
  targetAudiencesInfos: { data: [] },
  businessArchetype: null,
};

function StepFourthPass({
  setStep,
  targetAudienceRef,
  productRef,
  imageUrl,
  legend,
  setLegend,
  selectFunnel,
  headlineGpt,
  setHeadlineGpt,
  publicationDescriptionRef,
  imageArray,
  nincheData,
  hasSignature,
  imageGaleryArray,
  imageAIArray,
  imageUploadArray,
  imageProductsArray,
  // setIaData,
  // iaData,
  setImageUrl,
  setImageLayers,
  imageLayers,
  selectedFormat,
  returnToStepRef,
  flowCode,
  referenceArt,
}) {
  const [loading, setLoading] = useState(true);
  const [loadImage, setLoadImage] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [isCancelArtPendingPopUpOpen, setIsCancelArtPendingPopUpOpen] =
    useState(false);
  const [regerateLegendData, setRegerateLegendData] = useState(null);
  const [editArtData, setEditArtData] = useState(null);
  const [editImageChange, setEditImageChange] = useState(null);
  const [editImageReference, setEditImageReference] = useState(null);
  const [headlineGptLocal, setHeadlineGptLocal] = useState(null);
  // const [imageFreepik, setImageFreepik] = useState(null)
  const { clientData, allClientData } = useClient();
  // Hook trata da geração de arte (imagem e texto)
  const {
    artStatus,
    handleStartImageGeneration,
    handleStartReferenceImageGeneration,
    handleEditImageGeneration,
    handleApplyShamanSeal,
    handleGenerateLegend,
    handleDeleteWhenVisualized,
    handleRegenerateReferenceImage,
    handleEditImageGenerationWithReference,
    setShowSnackBar,
    setArtStatus
  } = UseGenerateArt();


  const [conversationId, setConversationId] = useState(null);
  const [isUsingReferenceArt, setIsUsingReferenceArt] = useState(false);
  const [legendConversationId, setLegendConversationId] = useState('');
  const [imgs64State, setImgs64State] = useState([]);
  const [isUsingBackgroundImage, setIsUsingBackgroundImage] = useState(false);
  const [isUsingPrincipalImage, setIsUsingPrincipalImage] = useState(false);
  const [hasShamanSeal, setHasShamanSeal] = useState(false);
  const [featureData, setFeatureData] = useState({
    artGenerationCount: 0,
    SinglePostLimit: 0,
  });

  const { setExpandSideMenu } = useContext(SideMenuContext);
  const generationAbortControllerRef = useRef(null);
  const countedImageUrlRef = useRef(null);
  const pendingArtConsumptionRef = useRef(null);
  const consumedArtStatusIdsRef = useRef([]);

  const { t } = useTranslation();
  const navigation = useNavigate();

  const { restartTimer, clearTimer, setShouldRenderChat } =
    useContext(ChatTimerContext);

  const CONSUMED_ART_STATUS_STORAGE_KEY = 'new-publication-ia-consumed-art-status-ids';
  const PENDING_ART_CONSUMPTION_STORAGE_KEY = 'new-publication-ia-pending-art-consumption';

  const readConsumedArtStatusIds = () => {
    if (typeof window === 'undefined') {
      return [];
    }

    try {
      const storedIds = JSON.parse(
        window.sessionStorage.getItem(CONSUMED_ART_STATUS_STORAGE_KEY) ?? '[]'
      );

      return Array.isArray(storedIds) ? storedIds : [];
    } catch {
      return [];
    }
  };

  const persistConsumedArtStatusIds = (ids) => {
    if (typeof window === 'undefined') {
      return;
    }

    window.sessionStorage.setItem(
      CONSUMED_ART_STATUS_STORAGE_KEY,
      JSON.stringify(ids)
    );
  };

  const hasConsumedArtStatus = (uuid) =>
    !!uuid && consumedArtStatusIdsRef.current.includes(uuid);

  const markArtStatusAsConsumed = (uuid) => {
    if (!uuid) {
      return;
    }

    const nextIds = mergeConsumedArtStatusIds(
      consumedArtStatusIdsRef.current,
      uuid
    );

    consumedArtStatusIdsRef.current = nextIds;
    persistConsumedArtStatusIds(nextIds);
  };

  const readPendingArtConsumption = () => {
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      const storedPending = JSON.parse(
        window.sessionStorage.getItem(PENDING_ART_CONSUMPTION_STORAGE_KEY) ??
        'null'
      );

      return storedPending?.artStatusId ? storedPending : null;
    } catch {
      return null;
    }
  };

  const registerPendingArtConsumption = (artStatusId) => {
    if (!artStatusId || typeof window === 'undefined') {
      return;
    }

    const payload = { artStatusId };
    pendingArtConsumptionRef.current = payload;
    window.sessionStorage.setItem(
      PENDING_ART_CONSUMPTION_STORAGE_KEY,
      JSON.stringify(payload)
    );
  };

  const clearPendingArtConsumption = () => {
    pendingArtConsumptionRef.current = null;

    if (typeof window === 'undefined') {
      return;
    }

    window.sessionStorage.removeItem(PENDING_ART_CONSUMPTION_STORAGE_KEY);
  };

  useEffect(() => {
    setExpandSideMenu(false);
    consumedArtStatusIdsRef.current = readConsumedArtStatusIds();
    pendingArtConsumptionRef.current = readPendingArtConsumption();

    const savedConversationId = localStorage.getItem(
      'art_edit_conversation_id'
    );
    if (savedConversationId) {
      setConversationId(savedConversationId);
    }

  }, []);

  useEffect(() => {
    const pendingArtConsumption =
      pendingArtConsumptionRef.current ?? readPendingArtConsumption();

    if (
      artStatus?.status === 'ERROR' &&
      pendingArtConsumption?.artStatusId === artStatus?.uuid
    ) {
      clearPendingArtConsumption();
    }
  }, [artStatus?.status, artStatus?.uuid]);

  const handleConsumeArtAfterVisualization = async () => {
    const pendingArtConsumption =
      pendingArtConsumptionRef.current ?? readPendingArtConsumption();
    const currentArtStatusId = artStatus?.uuid;

    if (!currentArtStatusId) {
      return;
    }

    if (pendingArtConsumption?.artStatusId !== currentArtStatusId) {
      return;
    }

    if (hasConsumedArtStatus(currentArtStatusId)) {
      clearPendingArtConsumption();
      return;
    }

    const consumptionResult = await consumeGeneratedArts(1, {
      eventType: 'new_publication_page_ia_art_visualized',
    });

    if (!consumptionResult?.success) {
      console.error('Falha ao consumir arte gerada após visualização', {
        artStatusId: currentArtStatusId,
        userPlanCountId: consumptionResult?.userPlanCountId ?? null,
        responseStatus: consumptionResult?.responseStatus ?? null,
        reason: consumptionResult?.reason ?? null,
      });
      return;
    }

    markArtStatusAsConsumed(currentArtStatusId);
    clearPendingArtConsumption();
  };

  useEffect(() => {
    if (artStatus && Object.keys(artStatus).length !== 0) {
      setLoading(artStatus?.status === 'PENDING');
      if (artStatus?.status !== 'PENDING' && !artStatus?.isVisualized) {
        setLoading(false);
        setImageUrl(artStatus?.status === 'ERROR' ? '' : artStatus?.imageUrl);
        setLegend(artStatus?.description);
        setShowSnackBar(false);
      }

      if (artStatus?.status !== 'PENDING' && artStatus?.isVisualized && !imageUrl) {
        handleLoadData()
      }

    } else {
      handleLoadData()
    }
  }, [artStatus]);

  const handleClickChangeStep = (step) => {
    setShouldRenderChat(false);
    if (step === 'stepFirstPass') {
      setImageUrl('');
    }

    setStep(step);
  };

  const handleUpenPopUp = () => {
    setOpenPopUp(true);
  };

  const getGenerationRequestSignal = () => {
    if (generationAbortControllerRef.current) {
      generationAbortControllerRef.current.abort();
    }

    const controller = new AbortController();
    generationAbortControllerRef.current = controller;

    return controller.signal;
  };

  const clearGenerationAbortController = () => {
    generationAbortControllerRef.current = null;
  };

  const textCopy = (textcopy) => {
    navigator.clipboard
      .writeText(textcopy)
      .then(() => {
        notifySuccessCustom('Copiado');
      })
      .catch((err) => {
        console.error('Erro ao copiar texto: ', err);
      });
  };

  const getImageLogo = async () => {
    const logoBase64 = [];

    if (clientData?.uuid) {
      const clientLogo = await LogosService.getLogosByClientBase64(
        clientData?.uuid
      );

      if (clientLogo?.length !== 0 && clientLogo) {
        clientLogo.data.forEach((logo) => {
          logoBase64.push({ base64: logo.fileBase64 });
        });
      }
    } else {
      const config = {};
      const userLogo = await LogosService.getLogosUserBase64(config);

      if (userLogo?.length !== 0 && userLogo) {
        userLogo.data.forEach((logo) => {
          logoBase64.push({ base64: logo.fileBase64 });
        });
      }
    }

    return logoBase64;
  };

  const loadFeatureData = async () => {
    try {
      const userSubscriptionFeatures = await SubscriptionService.getSubscriptionFeatures();
      // console.log('userSubscriptionFeatures', userSubscriptionFeatures);
      const singlePostLimit =
        userSubscriptionFeatures.data.singlePostLimit ?? 0;
      const additionalSinglePostQuantity =
        userSubscriptionFeatures.data.additionalSinglePostQuantity ?? 0;
      setFeatureData({
        artGenerationCount: userSubscriptionFeatures.data.artGenerationCount ?? 0,
        SinglePostLimit: singlePostLimit + additionalSinglePostQuantity,
      });
    } catch (error) {
      console.error('Erro ao carregar dados de features:', error);
    }
  };

  const checkSinglePostLimitAvailability = async () => {
    const { hasAvailableArts } = await getArtGenerationAvailability(1);

    if (hasAvailableArts === false) {
      notifyWarningCustom(
        t('plans.user_plan_count_no_available_arts_to_generate')
      );
      return false;
    }

    return true;
  };

  const checkPlanLimitlegend = async () => {
    const userPlanCountResponse = await UserPlanCount.getUserPlanCountByUser();
    const userSubscription = await SubscriptionService.getSubscriptionByUser();
    const userPlanCountData = Array.isArray(userPlanCountResponse?.data)
      ? userPlanCountResponse.data[0]
      : userPlanCountResponse?.data;
    const subscriptionData = Array.isArray(userSubscription?.data)
      ? userSubscription.data
      : [];
    const mesAtual = new Date(new Date().setDate(1)); // Primeiro dia do mês atual
    mesAtual.setDate(mesAtual.getDate() + 30);
    mesAtual.setHours(0, 0, 0, 0);
    const renewalDatePayload =
      subscriptionData.length > 0 ? subscriptionData[0].expiration : mesAtual;
    const userPlanCountId = userPlanCountData?.uuid ?? userPlanCountData?.id;

    if (!userPlanCountData) {
      await UserPlanCount.postUserPlanCount({
        ownScheduleCount: 0,
        postOnDesignCount: 0,
        imageBankCount: 0,
        aiImageCount: 0,
        aiLegendCount: 1,
        aiMessageCount: 0,
        renewalDate: renewalDatePayload,
      });
      return true;
    }

    const renewalDate = new Date(userPlanCountData.renewalDate);
    const dataAtual = new Date();
    const expirationPlan =
      subscriptionData.length > 0
        ? new Date(subscriptionData[0].expiration)
        : new Date(mesAtual);
    const isSameRenewalDay =
      renewalDate.getUTCFullYear() === expirationPlan.getUTCFullYear() &&
      renewalDate.getUTCMonth() === expirationPlan.getUTCMonth() &&
      renewalDate.getUTCDate() === expirationPlan.getUTCDate();

    if (renewalDate.getTime() < dataAtual.getTime() || !isSameRenewalDay) {
      if (!userPlanCountId) {
        return true;
      }

      await UserPlanCount.putUserPlanCount(userPlanCountId, {
        ownScheduleCount: 0,
        postOnDesignCount: 0,
        imageBankCount: 0,
        aiImageCount: 0,
        aiLegendCount: 1,
        aiMessageCount: 0,
        renewalDate: renewalDatePayload,
      });
      return true;
    }

    if (!userPlanCountId) {
      return true;
    }

    await UserPlanCount.putUserPlanCount(userPlanCountId, {
      ownScheduleCount: userPlanCountData.ownScheduleCount,
      postOnDesignCount: userPlanCountData.postOnDesignCount,
      imageBankCount: userPlanCountData.imageBankCount,
      aiImageCount: userPlanCountData.aiImageCount,
      aiLegendCount: userPlanCountData.aiLegendCount + 1,
      aiMessageCount: userPlanCountData.aiMessageCount,
      renewalDate: userPlanCountData.renewalDate,
    });
    return true;
  };

  function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');

    if (/^[0-9A-Fa-f]{6}$|^[0-9A-Fa-f]{3}$/.test(hex)) {
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map(function (char) {
            return char + char;
          })
          .join('');
      }

      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);

      return `(${r},${g},${b})`;
    } else {
      return `(${0},${0},${0})`;
    }
  }

  const loadBusinessData = async () => {
    try {
      if (clientData?.uuid) {
        const businessByClientReturn = await BusinessService.getBusinessByClientId(
          clientData?.uuid
        );

        const businessRecord = businessByClientReturn?.data?.[0];
        if (!businessRecord?.uuid) {
          return EMPTY_BUSINESS_DATA;
        }

        const brandingInfos = await BrandingService.getAllBrandingByBusinessId(
          businessRecord.uuid
        );

        const voiceToneInfos = await VoiceToneService.getAllVoiceToneByBusinessId(
          businessRecord.uuid
        );

        const targetAudiencesInfos =
          await TargetAudienceService.getAllTargetAudienceByClientId(
            businessRecord.uuid
          );

        return {
          brandingInfos: brandingInfos,
          voiceToneInfos: voiceToneInfos,
          businessInfos: businessByClientReturn,
          targetAudiencesInfos: targetAudiencesInfos,
        };
      }

      const businessInfos = await BusinessService.getBusinessByLogin();
      if (!businessInfos?.data?.length) {
        return EMPTY_BUSINESS_DATA;
      }

      const brandingInfos = await BrandingService.getAllBrandingByBusiness();
      const voiceToneInfos = await VoiceToneService.getAllVoiceToneByBusiness();
      const targetAudiencesInfos =
        await TargetAudienceService.getAllTargetAudience();
      const businessArchetype =
        await BrandingArchetypeService.getBrandingArchetypeByBusiness();

      return {
        brandingInfos: brandingInfos,
        voiceToneInfos: voiceToneInfos,
        businessInfos: businessInfos,
        targetAudiencesInfos: targetAudiencesInfos,
        businessArchetype: businessArchetype,
      };
    } catch {
      return EMPTY_BUSINESS_DATA;
    }
  };

  const getDownloadFreepikCount = async () => {
    const userPlanCountResponse = await UserPlanCount.getUserPlanCountByUser();
    const userSubscription = await SubscriptionService.getSubscriptionByUser();
    const userPlanCountData = Array.isArray(userPlanCountResponse?.data)
      ? userPlanCountResponse.data[0]
      : userPlanCountResponse?.data;
    const subscriptionData = Array.isArray(userSubscription?.data)
      ? userSubscription.data
      : [];
    const mesAtual = new Date(new Date().setDate(1)); // Primeiro dia do mês atual
    mesAtual.setDate(mesAtual.getDate() + 30);
    mesAtual.setHours(0, 0, 0, 0);
    const renewalDatePayload =
      subscriptionData.length > 0 ? subscriptionData[0].expiration : mesAtual;
    const userPlanCountId = userPlanCountData?.uuid ?? userPlanCountData?.id;

    if (!userPlanCountData) {
      await UserPlanCount.postUserPlanCount({
        ownScheduleCount: 0,
        postOnDesignCount: 0,
        imageBankCount: 1,
        aiImageCount: 0,
        aiLegendCount: 0,
        aiMessageCount: 0,
        renewalDate: renewalDatePayload,
      });
    } else {
      const renewalDate = new Date(userPlanCountData.renewalDate);
      const dataAtual = new Date();
      const expirationPlan =
        subscriptionData.length > 0
          ? new Date(subscriptionData[0].expiration)
          : new Date(mesAtual);
      const isSameRenewalDay =
        renewalDate.getUTCFullYear() === expirationPlan.getUTCFullYear() &&
        renewalDate.getUTCMonth() === expirationPlan.getUTCMonth() &&
        renewalDate.getUTCDate() === expirationPlan.getUTCDate();

      if (renewalDate.getTime() < dataAtual.getTime() || !isSameRenewalDay) {
        if (userPlanCountId) {
          await UserPlanCount.putUserPlanCount(userPlanCountId, {
            ownScheduleCount: 0,
            postOnDesignCount: 0,
            imageBankCount: 1,
            aiImageCount: 0,
            aiLegendCount: 0,
            aiMessageCount: 0,
            renewalDate: renewalDatePayload,
          });
        }
      } else if (userPlanCountId) {
        await UserPlanCount.putUserPlanCount(userPlanCountId, {
          ownScheduleCount: userPlanCountData.ownScheduleCount,
          postOnDesignCount: userPlanCountData.postOnDesignCount,
          imageBankCount: userPlanCountData.imageBankCount + 1,
          aiImageCount: userPlanCountData.aiImageCount,
          aiLegendCount: userPlanCountData.aiLegendCount,
          aiMessageCount: userPlanCountData.aiMessageCount,
          renewalDate: userPlanCountData.renewalDate,
        });
      }
    }

    // const imgBase64 = []

    // imageArray.forEach(async (image) => {
    //   if (image.idFreepik) {
    //     const imageDownloaded = await FreepikService.getFreepikDownload(
    //       image.idFreepik
    //     )
    //     imgBase64.push({
    //       base64: imageDownloaded.data,
    //       imageCategory: image.categoryId,
    //       idFreepik: image.idFreepik,
    //     })
    //   } else {
    //     imgBase64.push({
    //       base64: image.base64,
    //       imageCategory: image.categoryId,
    //     })
    //   }
    // })
    // setImageFreepik(imgBase64)
  };

  const registerEvent = async (data) => {
    await EventMapService.postEventMap(data);
  };

  //verifica se é principal ou background no array de imagem
  const checkImagesTags = (type) => {
    const hasIAType = imageAIArray.some((e) => e.categoryId === type);
    const hasImageType = imageArray.some((e) => e.categoryId === type);
    const hasGaleryType = imageGaleryArray.some((e) => e.categoryId === type);
    const hasProdutType = imageProductsArray.some((e) => e.categoryId === type);
    return hasIAType || hasImageType || hasGaleryType || hasProdutType;
  };

  const getIaHeadline = async () => {
    if (targetAudienceRef.current) {
      if (targetAudienceRef.current.label == 'Nenhum') {
        targetAudienceRef.current = undefined;
      }
    }

    if (productRef.current) {
      if (productRef.current.label == 'Nenhum') {
        productRef.current = undefined;
      }
    }
    let getEditorialLine;
    let editorialLine;

    if (clientData?.uuid) {
      getEditorialLine = await EditorialLineService.getEditorialLineByClient(
        clientData?.uuid
      );
      editorialLine = getEditorialLine?.data?.[0]?.bodyJson;
    } else {
      getEditorialLine = await EditorialLineService.getEditorialLinebyLogin();
      editorialLine = getEditorialLine?.data?.[0]?.bodyJson;
    }

    const userPrompt = publicationDescriptionRef.current?.trim() || '';

    const hasBackground = checkImagesTags('Background');
    const hasPrincipal = checkImagesTags('Principal');

    const editorialBody = {
      flow: 'unique_publication',
      prompt: 'headline',
      post_description: publicationDescriptionRef.current, //editorialLine?.dados_da_marca?.descricao_negocio,
      description: publicationDescriptionRef.current,
      brand: editorialLine?.dados_da_marca?.nicho || userPrompt || 'Geral',
      funil: selectFunnel,
      has_background: hasBackground,
      has_principal_image: hasPrincipal,
      is_ia: true,
      editorial_line: {
        primary: {
          titulo: editorialLine?.linha_conteudo_principal?.titulo,
          descricao: editorialLine?.linha_conteudo_principal?.descricao,
        },
        secondary: [
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[1]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[1]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[1]?.exemplos_conteudo,
          },
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[2]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[2]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[2]?.exemplos_conteudo,
          },
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[3]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[3]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[3]?.exemplos_conteudo,
          },
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[4]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[4]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[4]?.exemplos_conteudo,
          },
        ],
      },
      niche: editorialLine?.dados_da_marca?.nicho || userPrompt || 'Geral',
      subniche: editorialLine?.dados_da_marca?.subnicho || '',
      business_description:
        editorialLine?.dados_da_marca?.descricao_negocio || userPrompt || '',
      target_public: {
        name: targetAudienceRef?.current?.name || '',
        gender: targetAudienceRef?.current?.genderValue || '',
        social_class:
          targetAudienceRef?.current?.socialClassValue.join(', ') || '',
        profession: targetAudienceRef?.current?.profession || '',
        region: 'Nacional, com foco em grandes centros urbanos',
      },
      product: {
        name: productRef.current?.name || '',
        type: productRef.current?.productTypeValue || '',
        description: productRef.current?.description || '',
        value: productRef.current?.price || '',
        promotional_value: productRef.current?.promotionalValue || '',
      },

      voice_tone: editorialLine?.tom_de_voz || '',
      voice_tone_description: editorialLine?.tipo_post || '',
      language:
        localStorage.i18nextLng == 'en' ? localStorage.i18nextLng : 'pt',
    };

    // let retEditorialLine = await PythonService.postPromptGPT(editorialBody)
    let retEditorialLine =
      await OrchestratorTextGenerationService.generateHeadline(editorialBody);
    // console.log('retEditorialLine', retEditorialLine)
    setHeadlineGpt(retEditorialLine);
    setHeadlineGptLocal(retEditorialLine);

    setRegerateLegendData({
      niche: editorialLine?.dados_da_marca?.nicho || userPrompt || 'Geral',
      subniche: editorialLine?.dados_da_marca?.subnicho || '',
      voice_tone: editorialLine?.tom_de_voz || '',
      business_description:
        editorialLine?.dados_da_marca?.descricao_negocio || userPrompt || '',
    });

    return { retEditorialLine, editorialLine };
  };
  const { updateUrlWithArtGeneratedEvent } = useGoogleAdsTracking();

  const getIaImages = async (loadbusiness, headline, editorialLine) => {
    let getEditorialLine;

    const hasReferenceArt = referenceArt?.base64;

    if (!isEmpty(nincheData) && !hasReferenceArt) {
      if (clientData?.uuid) {
        getEditorialLine = await EditorialLineService.getEditorialLineByClient(
          clientData?.uuid
        );

        // console.log('editorialLine', getEditorialLine)
        editorialLine = getEditorialLine[0].bodyJson;
      } else {
        getEditorialLine = await EditorialLineService.getEditorialLinebyLogin();
        editorialLine = getEditorialLine?.bodyJson;
        // console.log('editorialLine', getEditorialLine)
      }
    }

    let businessData = loadbusiness;
    const userPrompt = publicationDescriptionRef.current?.trim() || '';
    const resolvedNiche = resolveNiche(businessData, userPrompt);
    const resolvedBrandColors = resolveBrandColors(businessData);
    const businessRecord = getBusinessRecord(businessData);
    const brandingRecord = getBrandingRecord(businessData);

    const imgBase64 = [];
    const logoBase64 = [];

    const findFont1 =
      brandingRecord?.fontsBase64?.fontTitleBase64?.data || '';
    const findFont2 =
      brandingRecord?.fontsBase64?.fontSubtitleBase64?.data || '';
    const findFont3 =
      brandingRecord?.fontsBase64?.fontTextBase64?.data || '';

    // Removido até ajustar a adição de logo no novo orchestrator

    if (clientData?.uuid) {
      const clientLogo = await LogosService.getLogosByClientBase64(
        clientData?.uuid
      );

      if (clientLogo?.length !== 0 && clientLogo) {
        clientLogo.data.forEach((logo) => {
          logoBase64.push({ base64: logo.fileBase64 });
        });
      }
    } else {
      const config = {};
      const userLogo = await LogosService.getLogosUserBase64(config);

      if (userLogo?.length !== 0 && userLogo) {
        userLogo.data.forEach((logo) => {
          logoBase64.push({ base64: logo.fileBase64 });
        });
      }
    }

    let bodyGenerateArt;

    const format = getFormatName(selectedFormat?.formatDimension);

    bodyGenerateArt = {
      generate_legend: true,
      headline: headline.data,
      requires_improvement: true,
      publications_number: 1, //! Padrao
      template: false,
      art_width: 1080,
      art_height: 1350,
      format: format,

      color_palette_1: hexToRgb(resolvedBrandColors[0]),
      color_palette_2: hexToRgb(resolvedBrandColors[1]),
      color_palette_3: hexToRgb(resolvedBrandColors[2]),
      color_palette_4: '(0,0,0)', //! Padrao
      color_palette_5: '(255,255,255)', //! Padrao
      editorial_line: {
        primary: {
          titulo: editorialLine?.linha_conteudo_principal?.titulo,
          descricao: editorialLine?.linha_conteudo_principal?.descricao,
        },
        secondary: [
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[1]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[1]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[1]?.exemplos_conteudo,
          },
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[2]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[2]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[2]?.exemplos_conteudo,
          },
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[3]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[3]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[3]?.exemplos_conteudo,
          },
          {
            titulo: editorialLine?.linhas_conteudo_secundarias?.[4]?.titulo,
            descricao: editorialLine?.linhas_conteudo_secundarias?.[4]?.descricao,
            exemplos_conteudo:
              editorialLine?.linhas_conteudo_secundarias?.[4]?.exemplos_conteudo,
          },
        ],
      },
      niche: resolvedNiche,
      subniche: businessRecord?.subNiche || '',
      escolaridade: targetAudienceRef.current?.educationLevelValue || '',
      publication_purpose: 'divulgar', //! Padrao
      language:
        localStorage.i18nextLng == 'en' ? localStorage.i18nextLng : 'pt',
      description: userPrompt || businessRecord?.description || '',
      post_description: userPrompt,
      brand: userPrompt || resolvedNiche,
      voice_tone: businessData?.voiceToneInfos?.data?.[0]?.tone || '',
      social_class: targetAudienceRef.current
        ? targetAudienceRef.current.socialClassValue
        : '',
      gender: targetAudienceRef.current?.genderValue || '',
      profession: targetAudienceRef.current?.profession || '',
      name_product: productRef.current?.name || '',
      product_type: productRef.current?.productTypeValue || '',
      product_description: productRef.current?.description || '',
      value: productRef.current?.price || '',
      promotional_value: productRef.current?.promotionalValue || '',
      produto: productRef.current?.name || '',
      product: productRef.current?.name || '',
      complexidade: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsSimpleOrComplex
        : 0,
      masculino: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsFemaleOrMale
        : 0,
      extravagante: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsSubtleOrExtravagant
        : 0,
      moderno: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsClassicOrModern
        : 0,
      distante: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsFriendlyOrDistant
        : 0,
      serio: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsPlayfulOrSerious
        : 0,
      industrial: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsNaturalOrIndustrial
        : 0,
      elitizado: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsPopularOrElite
        : 0,
      sofisticado: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsStrippedOrSophisticated
        : 0,
      refinado: businessData.businessArchetype
        ? businessData.businessArchetype.data[0]?.bpsRusticOrRefined
        : 0,
      macro_effects: false,
      num_imgs: [1],
      has_logo: logoBase64.length > 0 ? true : false,
      fonte_1: findFont1 || 'montserrat',
      fonte_2: findFont2 || 'roboto',
      fonte_3: findFont3 || 'protestriot',
      hasSignature: hasSignature,
      logo_base64: logoBase64,
    };

    let sequenceId = 1;

    if (imageArray?.length !== 0 && imageArray) {
      for (const image of imageArray) {
        if (image.idFreepik) {
          const imageDownloaded = await FreepikService.getFreepikDownload(
            image.idFreepik
          );
          imgBase64.push({
            base64: imageDownloaded.data,
            imageCategory: image.categoryId,
            idFreepik: image.idFreepik,
            id: sequenceId,
            fileFormat: 'image/jpeg',
          });
          await getDownloadFreepikCount();
          sequenceId++;
        } else {
          imgBase64.push({
            base64: image.base64,
            imageCategory: image.categoryId,
            id: sequenceId,
            fileFormat: 'image/jpeg',
          });
          sequenceId++;
        }
      }
    }

    if (imageGaleryArray?.length !== 0 && imageGaleryArray) {
      imageGaleryArray.forEach((image2) => {
        imgBase64.push({
          base64: image2.fileDataBase64.split(',')[1],
          imageCategory: image2.categoryId,
          id: sequenceId,
          fileFormat: image2.type,
        });
        sequenceId++;
      });
    }

    if (imageAIArray.length !== 0 && imageAIArray) {
      imageAIArray.forEach((image2) => {
        const match = image2.image.match(/^data:(.*?);base64,/);

        imgBase64.push({
          base64: image2.image.split(',')[1],
          imageCategory: image2.categoryId,
          id: sequenceId,
          fileFormat: match ? match[1] : null,
        });
        sequenceId++;
      });
    }

    if (imageUploadArray.length !== 0 && imageUploadArray) {
      imageUploadArray.forEach((image2) => {
        imgBase64.push({
          base64: image2.image.split(',')[1],
          imageCategory: image2.categoryId,
          id: sequenceId,
          fileFormat: image2.type,
        });
        sequenceId++;
      });
    }

    if (imageProductsArray.length !== 0 && imageProductsArray) {
      imageProductsArray.forEach((image2) => {
        imgBase64.push({
          base64: image2.fileDataBase64.split(',')[1],
          imageCategory: image2.categoryId,
          productId: image2.productId,
          productName: image2.productName,
          productDescription: image2.productDescription,
          productValue: image2.productValue,
          productPromotionValue: image2.productPromotionValue,
          fileFormat: image2.type,
        });
      });
    }

    if (imgBase64.length === 0) {
      setIsUsingBackgroundImage(false);
      setIsUsingPrincipalImage(false);
    }

    const hasBackground = imgBase64.some(
      (e) => e.imageCategory === 'Background'
    );
    const hasPrincipal = imgBase64.some((e) => e.imageCategory === 'Principal');

    setIsUsingBackgroundImage(hasBackground);
    setIsUsingPrincipalImage(hasPrincipal);

    setImgs64State(imgBase64);

    let imgBase64Reference = undefined;

    if (referenceArt && referenceArt.base64) {
      const base64String = referenceArt.base64.includes(',')
        ? referenceArt.base64.split(',')[1]
        : referenceArt.base64;

      imgBase64Reference = base64String;
    }

    let bodyGenerateArtWithReference = {
      niche: resolvedNiche,
      brand: userPrompt || resolvedNiche,
      colors: resolvedBrandColors,
      objective:
        userPrompt ||
        editorialLine?.dados_da_marca?.descricao_negocio ||
        businessRecord?.description ||
        '',
      format: format,
      editorial_line: editorialLine,
      reference_image_base64: imgBase64Reference,
      img_base64: imgBase64,
      logo_base64: logoBase64,
    };

    if (nincheData && nincheData.VariantSelected) {
      bodyGenerateArt.specificTemplate = nincheData.VariantSelected;
    }

    bodyGenerateArt = {
      ...bodyGenerateArt,
      img_base64: imgBase64,
    };

    // const config = {};

    let generateArtReturn;

    let imageGenerationResponse;

    if (imgBase64Reference) {
      // generateArtReturn = await PythonService.postGenerateArtWithReference(
      //   bodyGenerateArtWithReference,
      //   config
      // );
      imageGenerationResponse = await handleStartReferenceImageGeneration(
        bodyGenerateArtWithReference,
        { signal: getGenerationRequestSignal() }
      );
      setIsUsingReferenceArt(true);
    } else {
      imageGenerationResponse = await handleStartImageGeneration(bodyGenerateArt, {
        signal: getGenerationRequestSignal(),
      });
      setIsUsingReferenceArt(false);
    }

    clearGenerationAbortController();

    if (imageGenerationResponse?.aborted) {
      return { isSuccessGeneratedImage: false, newHeadlinesReference: null };
    }

    const newConversationId = artStatus?.conversationId

    if (newConversationId) {
      setConversationId(newConversationId);
      localStorage.setItem('art_edit_conversation_id', newConversationId);
    } else {
      setConversationId(null);
      localStorage.removeItem('art_edit_conversation_id');
    }

    registerPendingArtConsumption(imageGenerationResponse?.data?.artStatusId);

    const hasReference = !!imgBase64Reference;
    const dataEvent = {
      event: hasReference ? 'art_generation_with_reference' : 'art_generation_without_reference',
      eventData: {
        publicationType: 'NewPublicationPageIa',
        flowCode: flowCode,
        hasReference: hasReference,
      },
    };
    await registerEvent(dataEvent);
    if (imgBase64Reference) {
      if (logoBase64.length === 0) {
        setImageUrl(
          'data:image/png;base64,' + generateArtReturn?.data?.data?.art_base64
        );
      } else {
        setImageUrl(
          'data:image/png;base64,' + generateArtReturn?.data?.data?.art_base64
        );
      }
      setImageLayers({
        ...generateArtReturn?.data?.data,

        regenerateData: {
          niche: bodyGenerateArtWithReference.niche,
          brand: bodyGenerateArtWithReference.brand,
          colors: bodyGenerateArtWithReference.colors,
          objective: bodyGenerateArtWithReference.objective,
          format: bodyGenerateArtWithReference.format,
          texts: {
            funil: selectFunnel,
            headlines: generateArtReturn?.data?.data?.new_headlines || [],
          },
        },
      });
    } else {
      if (logoBase64.length === 0) {
        setImageUrl(
          'data:image/png;base64,' +
          generateArtReturn?.data?.data[0].enhanced_art
        );
      } else {
        setImageUrl(
          'data:image/png;base64,' +
          generateArtReturn?.data?.data[0].enhanced_art_with_logo
        );
      }
      setImageLayers(generateArtReturn?.data?.data[0]);
    }

    const isSuccessGeneratedImage = !!artStatus?.imageUrl;

    let newHeadlinesReference = null;
    if (imgBase64Reference) {
      newHeadlinesReference =
        generateArtReturn?.data?.data?.new_headlines || null;
    }
    return { isSuccessGeneratedImage, newHeadlinesReference };
  };

  const fetchData = async () => {
    const loadbusiness = await loadBusinessData();
    const getIaHeadlineReturn = await getIaHeadline();
    // console.log('getIaHeadlineReturn', getIaHeadlineReturn)

    const result = await getIaImages(loadbusiness, getIaHeadlineReturn.retEditorialLine, getIaHeadlineReturn.editorialLine);
    const succesGenerated = result.isSuccessGeneratedImage;
    // const newHeadlinesReference = result.newHeadlinesReference;
    // await legendGenerate(getIaHeadlineReturn, newHeadlinesReference);
    clearTimer();
    setShouldRenderChat(true);

    if (succesGenerated && imageUrl && !imageUrl.includes('undefined')) {
      updateUrlWithArtGeneratedEvent();
    }
  };

  const handleShamanSealToggle = async (checked) => {
    try {
      setHasShamanSeal(checked);
      if (checked) {
        await handleApplyShamanSeal({});
      }
    } catch (error) {
      console.error('Error applying shaman seal:', error);
    }
  };

  const legendGenerate = async (getIaHeadlineReturn, newHeadlinesReference) => {
    let headline = undefined;

    if (getIaHeadlineReturn) {
      headline = getIaHeadlineReturn;
    } else if (newHeadlinesReference) {
      headline = newHeadlinesReference;
    } else {
      headline = headlineGpt.data.data.headlines;
    }

    let getEditorialLine;
    let editorialLine;

    if (clientData?.uuid) {
      getEditorialLine = await EditorialLineService.getEditorialLineByClient(
        clientData?.uuid
      );
      editorialLine = getEditorialLine?.data?.[0].bodyJson;
    } else {
      getEditorialLine = await EditorialLineService.getEditorialLinebyLogin();
      editorialLine = getEditorialLine?.data?.[0].bodyJson;
    }

    const legendPrompt = publicationDescriptionRef.current?.trim() || '';

    const bodyLegend = {
      flow: 'unique_publication',
      prompt: 'legend',
      post_description: legendPrompt,
      brand: editorialLine?.dados_da_marca?.nicho || legendPrompt || 'Geral',
      funil: selectFunnel,
      niche: editorialLine?.dados_da_marca?.nicho || legendPrompt || 'Geral',
      subniche: editorialLine?.dados_da_marca?.subnicho || '',
      business_description:
        editorialLine?.dados_da_marca?.descricao_negocio || legendPrompt || '',
      target_public: {
        name: targetAudienceRef?.current?.name || '',
        gender: targetAudienceRef?.current?.genderValue || '',
        social_class:
          targetAudienceRef?.current?.socialClassValue?.join(', ') || '',
        profession: targetAudienceRef?.current?.profession || '',
        region: 'Nacional, com foco em grandes centros urbanos',
      },
      voice_tone: editorialLine?.tom_de_voz || '',
      voice_tone_description: editorialLine?.tipo_post,
      product: {
        name: productRef?.current?.name || '',
        type: productRef?.current?.productTypeValue || '',
        description: productRef?.current?.description || '',
        value: productRef?.current?.price || '',
        promotional_value: productRef?.current?.promotionalValue || '',
      },
      headlines: headline,
      language:
        localStorage.i18nextLng == 'en' ? localStorage.i18nextLng : 'pt',
      instructions: '',
      conversation_id: legendConversationId,
    };

    if (await checkPlanLimitlegend()) {
      // let retEditorialLine = await PythonService.postPromptGPT(bodyLegend)

      // const generatedLegend = await handleGenerateLegend(bodyLegend)
      // setLegend(generatedLegend)

      const dataEvent = {
        event: 'legend',
        eventData: {
          origin: 'Post Completo IA',
          flowCode: flowCode,
        },
      };
      await registerEvent(dataEvent);

      return bodyLegend;
    }
  };

  const handleDownloadImage = async () => {
    try {
      if (!imageUrl) {
        notifyErrorCustom('Nenhuma imagem disponível para download');
        return;
      }

      // Registrar evento
      const dataEvent = {
        event: 'art_downloaded',
        eventData: {
          origin: 'Post Completo IA',
          flowCode: flowCode,
        },
      };
      registerEvent(dataEvent);

      let base64Data;
      let mimeType = 'image/png';

      // Se já for base64, usar direto
      if (imageUrl.startsWith('data:')) {
        base64Data = imageUrl.split(',')[1];
        mimeType = imageUrl.match(/data:(.*?);base64/)?.[1] || 'image/png';
      } else {
        // Para URLs externas, fazer fetch
        try {
          const response = await fetch(imageUrl);
          if (!response.ok) throw new Error('Falha ao carregar imagem');

          const blob = await response.blob();
          mimeType = blob.type || 'image/png';

          // Converter blob para base64
          base64Data = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const result = reader.result;
              resolve(result.split(',')[1]);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (fetchError) {
          console.error('Erro ao fazer fetch da imagem:', fetchError);
          notifyErrorCustom('Erro ao baixar a imagem. Tente novamente.');
          return;
        }
      }

      // Converter base64 para Blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });

      // Criar URL temporário e fazer download
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;

      // Definir extensão baseada no tipo MIME
      const extension = mimeType.includes('png') ? '.png' : '.jpg';
      link.download = `imagem_gerada${extension}`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Liberar URL temporário após um pequeno delay
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 100);

      notifySuccessCustom('Download realizado com sucesso');

      // Reinicia o timer do chat
      clearTimer();
      restartTimer();
    } catch (error) {
      console.error('Erro ao fazer download da imagem:', error);
      notifyErrorCustom('Erro ao baixar a imagem. Tente novamente.');
    }
  };

  const handleNavigateRestarTimer = (route) => {
    restartTimer();
    navigation(route);
  };

  const handleLoadData = async () => {
    setLoading(true)

    const hasAvailableArts = await checkSinglePostLimitAvailability();

    if (!hasAvailableArts) {
      setLoading(false);
      return;
    }

    await fetchData();
  };

  const onGenerateAgain = () => handleLoadData()


  const FooterField = ({ hasArtPending, onClickCancelArtPending }) => {
    return (
      <>
        <div className={styles.button_nav}>
          <SecondaryButton
            onClick={() => hasArtPending ? onClickCancelArtPending() : handleClickChangeStep('stepFirstPass')}
            size="medium"
          >
            {hasArtPending ? 'Voltar' : t('back_buttom')}
          </SecondaryButton>
          <div
            style={{
              display: 'flex',
              gap: '10px',
              pasition: 'fixed',
              marginRight: 20,
            }}
          >
            <PrimaryButton
              onClick={() => handleUpenPopUp(true)}
              size="medium"
            >
              {t('new_publication_page_fourth_pass_finish_scheduling')}
            </PrimaryButton>
          </div>
        </div>
      </>
    );
  };

  const getFormatName = (dimesions) => {
    if (dimesions === '1024x1024') {
      return 'quadrado';
    }
    if (dimesions == '1536x1024') {
      return 'horizontal';
    }
    if (dimesions == '1024x1536') {
      return 'vertical';
    }
    return 'quadrado';
  };

  const editTemplate = async () => {
    setLoading(true);

    const hasAvailableArts = await checkSinglePostLimitAvailability();

    if (!hasAvailableArts) {
      setLoading(false);
      return;
    }

    // const format = (() => {
    //   if(editArtData.art_width > editArtData.art_height){
    //     return 'horizontal'
    //   }
    //   if(editArtData.art_width == editArtData.art_height){
    //     return 'quadrado'
    //   }
    //   if(editArtData.art_width < editArtData.art_height){
    //     return 'vertical'
    //   }
    //   return ''
    // })()

    // Processar imagens de "Alterar imagem"
    let imgBase64Edit = undefined;
    let imageCategory = undefined;

    if (editImageChange && editImageChange.base64) {
      const base64String = editImageChange.base64.includes(',')
        ? editImageChange.base64.split(',')[1]
        : editImageChange.base64;

      imageCategory = getFirstImageWithCategory();

      imgBase64Edit = base64String;
    }

    // Processar imagens de "Anexar arte de referência"
    let imgBase64ReferenceEdit = undefined;
    if (editImageReference && editImageReference.base64) {
      const base64String = editImageReference.base64.includes(',')
        ? editImageReference.base64.split(',')[1]
        : editImageReference.base64;

      imgBase64ReferenceEdit = base64String;
    }

    const format = getFormatName(selectedFormat?.formatDimension);
    const logoBase64 = await getImageLogo();
    const shouldUseReferenceRoute = isUsingReferenceArt;

    let returnNewTemplate = null;

    setImageUrl('')
    if (shouldUseReferenceRoute) {

      const regenerateData =
        imageLayers?.regenerateData || editArtData?.regenerateData;

      // Obter imagem principal atual
      let mainImageBase64 = imageLayers?.art_base64 || '';
      if (!mainImageBase64 && imageUrl && imageUrl.includes('base64,')) {
        mainImageBase64 = imageUrl.split('base64,')[1];
      }

      if (imgBase64Edit) {
        mainImageBase64 = imgBase64Edit;
      }

      const userObjective = editArtData?.instructions?.trim() || '';
      const objectiveValue = userObjective || regenerateData?.objective || '';

      const bodyRegenerate = {
        niche: regenerateData?.niche || publicationDescriptionRef.current || 'Geral',
        brand: regenerateData?.brand || publicationDescriptionRef.current || 'Geral',
        colors:
          Array.isArray(regenerateData?.colors) && regenerateData.colors.length >= 3
            ? regenerateData.colors
            : DEFAULT_BRAND_COLORS,
        objective: objectiveValue,
        format: regenerateData?.format || format,
        texts: regenerateData?.texts || {
          funil: selectFunnel,
          headlines: editArtData?.new_headlines || [],
        },
        main_image_base64: mainImageBase64,
        reference_image_base64: imgBase64ReferenceEdit,
        img_base64: imgs64State,
        existentLegend: legend,
        instructions: editArtData.instructions.trim(),
      };


      const bodyEditArt = {
        artStatusId: artStatus?.uuid,
        instructions: editArtData.instructions.trim(),
        format: format,
        conversationId: artStatus?.conversationId,
        additional_image_base64: imgs64State || undefined,
        // new_headlines: editArtData?.new_headlines || undefined,
        colors:
          editArtData?.regenerateData?.colors?.length >= 3
            ? editArtData.regenerateData.colors
            : imageLayers?.regenerateData?.colors?.length >= 3
              ? imageLayers.regenerateData.colors
              : DEFAULT_BRAND_COLORS,
        niche:
          editArtData?.regenerateData?.niche ||
          imageLayers?.regenerateData?.niche ||
          publicationDescriptionRef.current ||
          'Geral',
        brand:
          editArtData?.regenerateData?.brand ||
          imageLayers?.regenerateData?.brand ||
          publicationDescriptionRef.current ||
          'Geral',
        reference_image_base64: ''
      };

      // returnNewTemplate = await PythonService.postRegenerateArtWithReference(
      //   bodyRegenerate
      // );

      if (!imgBase64ReferenceEdit) {
        if (referenceArt && referenceArt.base64) {
          const base64String = referenceArt.base64.includes(',')
            ? referenceArt.base64.split(',')[1]
            : referenceArt.base64;

          let imgBase64Reference = base64String;
          bodyEditArt.reference_image_base64 = imgBase64Reference
        }

        await handleEditImageGenerationWithReference(bodyEditArt, {
          signal: getGenerationRequestSignal(),
        })
        // console.log(bodyEditArt)
        clearGenerationAbortController()
        return
      } else {
        await handleRegenerateReferenceImage(bodyRegenerate, {
          signal: getGenerationRequestSignal(),
        });
      }

      clearGenerationAbortController()


      // let newHeadlines = editArtData.new_headlines;

      // const dataEditArtWithReference = {
      //   instructions: editArtData.instructions.trim(),
      //   conversation_id: conversationId,
      //   img_base64: imgs64State,
      //   format: format,
      //   ...(newHeadlines && { new_headlines: newHeadlines }),
      //   ...(imgBase64Edit && { additional_image_base64: imgBase64Edit }),
      // };

      // returnNewTemplate = await PythonService.postEditArtWithReference(
      //   dataEditArtWithReference
      // );

    } else {
      // Fluxo sem referência - delega para o hook gerenciar via artStatus context
      const dataEditArtPrompt = {
        format: format,
        instructions: editArtData?.instructions,
        template_name: artStatus?.templateName,
        art_width: editArtData?.art_width,
        art_height: editArtData?.art_height,
        image_base64: editArtData?.enhanced_art,
        logo_base64: logoBase64?.length > 0 ? logoBase64[0].base64 ?? '' : '',
        conversation_id: conversationId,
        additional_image_base64: imgBase64Edit ? imgBase64Edit : undefined,
        category: imageCategory?.length > 0 ? imageCategory[0] : undefined,
        img_base64: imageUrl,

      };

      // Atualiza o artStatus via hook - isto disparará o useEffect aqui
      // que monitora artStatus e atualizará a UI quando status for SUCCESS
      const editImageResponse = await handleEditImageGeneration(
        dataEditArtPrompt,
        {
          signal: getGenerationRequestSignal(),
        }
      );
      registerPendingArtConsumption(editImageResponse?.data?.artStatusId);

      clearGenerationAbortController();



    }

    // Fluxo com referência atualiza imageUrl imediatamente pois retorna a imagem pronta
    if (shouldUseReferenceRoute && returnNewTemplate?.data?.data) {
      const responseData = returnNewTemplate.data.data;
      const artBase64 = responseData.art_base64 || responseData.enhanced_art;

      setImageUrl('data:image/png;base64,' + artBase64);
      setImageLayers({
        ...editArtData,
        art_base64: artBase64,
        new_headlines: responseData.new_headlines,
      });

      // Para fluxo com referência (que já tem resposta pronta), desliga loading
      // setLoading(false);
    }

    // Para fluxo sem referência, o loading é controlado pelo useEffect que monitora artStatus
    // Assim tratamos erros corretamente sem pular o loading

    const hasReferenceEdit = !!imgBase64ReferenceEdit;
    const dataEvent = {
      event: hasReferenceEdit ? 'art_edit_with_reference' : 'art_edit',
      eventData: {
        publicationType: 'NewPublicationPageIa',
        flowCode: flowCode,
        hasReference: hasReferenceEdit,
      },
    };

    setEditArtData(null);
    setEditImageChange(null);
    setEditImageReference(null);

    await registerEvent(dataEvent);
  };


  const loadingLegendPress = async (gptInput) => {
    // const headline = generatedHeadline;
    const bodyLegend = {
      flow: 'unique_publication',
      prompt: 'legend',
      niche: regerateLegendData?.niche || '',
      subniche: regerateLegendData?.subniche || '',
      input: gptInput,
      voice_tone: regerateLegendData?.voice_tone,
      business_description: regerateLegendData?.business_description,
      language:
        localStorage.i18nextLng == 'en' ? localStorage.i18nextLng : 'pt',
    };

    if (await checkPlanLimitlegend()) {
      try {
        setLoading(true)
        const conversationId = artStatus?.legendConversationId
        const generatedLegend = await handleGenerateLegend({ ...bodyLegend, legendConversationId: conversationId });
        // console.log('generated legend', generatedLegend)
        setLegend(generatedLegend);

        const dataEvent = {
          event: 'legend',
          eventData: {
            origin: 'Post Completo IA',
            flowCode: flowCode,
          },
        };

        await registerEvent(dataEvent);
      } catch (error) {
        notifyErrorCustom(t('error_generating_legend'));
      }
    }


    setLoading(false);
  };

  const getFirstImageWithCategory = () => {
    // Verifica em todos os arrays de imagens
    const allImages = [
      ...imageArray,
      ...imageGaleryArray,
      ...imageAIArray,
      ...imageUploadArray,
      ...imageProductsArray,
    ];


    // Encontra a primeira imagem com categoryId definido
    const imageWithCategory = allImages.filter(
      (img) =>
        img?.categoryId === 'Principal' || img?.categoryId === 'Background'
    );

    return imageWithCategory;
  };

  const handleClickCancelArt = async () => {
    if (generationAbortControllerRef.current) {
      generationAbortControllerRef.current.abort();
      clearGenerationAbortController();
    }

    localStorage.setItem('pendingArtPopupShown', undefined)
    await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
    setArtStatus(null)
    setShowSnackBar(false)
    setIsCancelArtPendingPopUpOpen(false)
    navigation('/ChatSocket')
  }

  const handleOpenCancelArtPendingPopUp = () => {
    setIsCancelArtPendingPopUpOpen(true)
  }

  const handleCloseCancelArtPendingPopUp = () => {
    setIsCancelArtPendingPopUpOpen(false)
  }

  return (
    <>
      <ArtPendingCancelPopUp
        isOpen={isCancelArtPendingPopUpOpen}
        onConfirmCancel={handleClickCancelArt}
        onContinue={handleCloseCancelArtPendingPopUp}
      />
      {loading ? (
        <LoadingLayoutMemoized
          onClickCancelArtPending={handleOpenCancelArtPendingPopUp}
        />
      ) : (
        <div className={styles.container_page}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              flex: 1,
              maxWidth: '100%',
            }}
          >
            <div className={styles.container_features}>
              {/* <div className={styles.title_new_posts}>
                <p className={styles.title_new_posts_label}>Nova </p>
                <p className={styles.title_new_posts_title}>Publicação</p>
              </div> */}
              <div className={styles.title_new_posts_features}>
                {/* <p className={styles.title_new_posts_label}> Artes Geradas</p> */}
                <div className={styles.features}>
                  <p className={styles.current_number}>
                    {/* {featureData?.singlePostQuantity ?? 0} */}
                  </p>
                  <p className={styles.total_number}>
                    {/* /{featureData?.SinglePostLimit ?? 0} */}
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.container_content}>
              <div className={styles.container_image_example}>
                <ImageField
                  onCopyLegend={() => textCopy(legend)}
                  onDownloadImage={() => handleDownloadImage()}
                  onGenerateAgain={() => onGenerateAgain()}
                  imageUrl={imageUrl}
                  onLoad={async () => {
                    if (!imageUrl || countedImageUrlRef.current === imageUrl) {
                      await loadFeatureData();
                      return;
                    }

                    countedImageUrlRef.current = imageUrl;
                    await handleDeleteWhenVisualized()
                    await handleConsumeArtAfterVisualization();
                    await loadFeatureData();
                    await checkPlanLimitlegend();
                  }
                  }

                  hasShamanSeal={hasShamanSeal}
                  setHasShamanSeal={handleShamanSealToggle}
                />

                <MessagePopUp
                  isOpen={openPopUp}
                  onClose={() => setOpenPopUp(false)}
                  title={
                    <p style={{ fontFamily: 'Poppins', fontWeight: 400 }}>
                      {t('new_publication_page_ia_step_fourth_modal_title')}{' '}
                      <span
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: 500,
                          color: '#6A0098',
                        }}
                      >
                        {t('new_publication_page_ia_step_fourth_modal_title2')}
                      </span>
                    </p>
                  }
                  logo={Logo}
                  primaryButton={
                    <div
                      style={{ display: 'flex', gap: '16px', alignItems: 'center' }}
                    >
                      {t(
                        'new_publication_page_ia_step_fourth_modal_primary_button'
                      )}
                      <RocketIcon color="#fff" size={24} />
                    </div>
                  }
                  secondaryButton={t(
                    'new_publication_page_ia_step_fourth_modal_secondary_button'
                  )}
                  onClickSecondaryBtn={() => handleClickChangeStep('stepFinish')}
                  onClickPrimaryBtn={() =>
                    handleClickChangeStep('stepPublicationSuccess')
                  }
                  content={
                    <p style={{ textAlign: 'center' }}>
                      {t('new_publication_page_ia_step_fourth_modal_title3')}
                    </p>
                  }
                />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 15,
                    flex: 1,
                  }}
                >
                  <EditArtField
                    isUsingBackgroundImage={isUsingBackgroundImage}
                    isUsingPrincipalImage={isUsingPrincipalImage}
                    disabled={imageUrl?.includes('undefined') || !imageUrl}
                    selectedImageCategory={() => getFirstImageWithCategory()}
                    isUsingReferenceArt={isUsingReferenceArt}
                    onChangePromptEditArt={(inputStr) => {
                      setEditArtData({
                        ...imageLayers,
                        instructions: inputStr,
                      });
                    }}
                    onChangeReferenceArt={(imageData) => {
                      setEditImageReference(imageData);
                    }}
                    onChangeImage={(newImageArray) => {
                      setImgs64State(newImageArray);
                    }}
                    onClickSendEditArtPrompt={editTemplate}
                  />
                  <EditLegendField
                    onCopyLegend={() => textCopy(legend)}
                    legend={legend}
                    setLegend={setLegend}
                    onGenerateSubtitle={loadingLegendPress}
                  />
                </div>
              </div>
            </div>
          </div>
          <FooterField
            hasArtPending={artStatus?.status === 'PENDING' && !artStatus?.isVisualized}
            onClickCancelArtPending={handleOpenCancelArtPendingPopUp}
          />
        </div>
      )}
    </>
  );
}

export default StepFourthPass;
